import moment from "moment";

export const MONTHLY_BRAND_LIMIT_EXCEEDED = "MONTHLY_BRAND_LIMIT_EXCEEDED";

export const REDEMPTION_ALLOWANCE_COPY = {
  blockedBadge: "Monthly limit reached",
  blockedReason: (resetsOnLabel) =>
    resetsOnLabel
      ? `You have used this brand's monthly allowance. Resets on ${resetsOnLabel}.`
      : "You have used this brand's monthly allowance.",
  remaining: (remaining) => `${remaining} remaining this month`,
  resetsOn: (resetsOnLabel) => `Resets on ${resetsOnLabel}`,
  monthlyLimitExceeded: (resetsOnLabel) =>
    resetsOnLabel
      ? `You've reached this brand's monthly redemption limit. You can redeem again after ${resetsOnLabel}.`
      : "You've reached this brand's monthly redemption limit. Please try again next month.",
};

const emptyAllowance = {
  month: "",
  timezone: "",
  resetsOn: "",
  generatedAt: "",
  groups: [],
  unattributed: null,
  failed: false,
};

const normalizeKey = (value) =>
  value === undefined || value === null ? "" : String(value).trim().toLowerCase();

export const formatAllowanceDate = (value) => {
  if (!value) return "";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("DD MMM YYYY") : "";
};

export const normalizeAllowance = (payload = {}) => ({
  month: payload?.month || "",
  timezone: payload?.timezone || "",
  resetsOn: payload?.resetsOn || "",
  generatedAt: payload?.generatedAt || "",
  groups: Array.isArray(payload?.groups) ? payload.groups : [],
  unattributed: payload?.unattributed || null,
  failed: false,
});

export const getFailedAllowance = () => ({ ...emptyAllowance, failed: true });

const getRewardGroupKeys = (reward) => {
  const customFields = reward?.customFields || reward?.customField || {};
  const keys = [
    reward?.group,
    reward?.groupName,
    reward?.rewardGroup,
    reward?.brand,
    reward?.brandName,
    reward?.brandId,
    reward?.intouchPoints,
    reward?.intouchSeriesId,
    customFields?.group,
    customFields?.brand,
  ];

  return keys.map(normalizeKey).filter(Boolean);
};

export const findAllowanceGroup = (reward, groups = []) => {
  if (!reward || !groups.length) return null;

  const rewardKeys = new Set(getRewardGroupKeys(reward));
  if (!rewardKeys.size) return null;

  return (
    groups.find((item) => rewardKeys.has(normalizeKey(item?.group))) || null
  );
};

export const isRewardBlocked = (reward, allowance) =>
  Boolean(findAllowanceGroup(reward, allowance?.groups)?.blocked);

export const getBlockedReason = (allowance) =>
  REDEMPTION_ALLOWANCE_COPY.blockedReason(formatAllowanceDate(allowance?.resetsOn));

const collectErrorValues = (payload) => {
  if (!payload) return [];

  return [
    payload?.code,
    payload?.errorCode,
    payload?.error_code,
    payload?.status?.code,
    payload?.status?.message,
    payload?.message,
    payload?.errors?.[0]?.code,
    payload?.errors?.[0]?.errorCode,
    payload?.errors?.[0]?.message,
    payload?.data?.code,
    payload?.data?.errorCode,
    payload?.data?.errors?.[0]?.code,
    payload?.data?.errors?.[0]?.message,
    payload?.data?.status?.message,
  ].filter(Boolean);
};

export const hasMonthlyBrandLimitExceeded = (payload) =>
  collectErrorValues(payload).some((value) =>
    String(value).includes(MONTHLY_BRAND_LIMIT_EXCEEDED),
  );

export const getMonthlyLimitErrorMessage = (allowance) =>
  REDEMPTION_ALLOWANCE_COPY.monthlyLimitExceeded(
    formatAllowanceDate(allowance?.resetsOn),
  );
